import { useEffect, useMemo, useState } from 'react'

import { getScaleFactor, getSeatingOffsets } from '../helpers'

export const useTransformComponentDimensions = (data, wrapperRef) => {
    const [maxSeatingChildrenX, setMaxSeatingChildrenX] = useState(0)
    const [maxSeatingChildrenY, setMaxSeatingChildrenY] = useState(0)
    const [scaleFactor, setScaleFactor] = useState(1.2)
    const clientWidth = wrapperRef.current?.clientWidth
    const currentWrapperRef = wrapperRef.current

    useEffect(() => {
        if (currentWrapperRef) {
            const resizeObserver = new ResizeObserver((entries) => {
                if (entries[0]?.contentRect?.width) {
                    const containerWidth = entries[0].contentRect.width
                    const scaleFactor = getScaleFactor(containerWidth)
                    setScaleFactor(scaleFactor)
                }
            })

            resizeObserver.observe(currentWrapperRef)

            return () => {
                resizeObserver.unobserve(currentWrapperRef)
            }
        }
    }, [])

    useEffect(() => {
        if (clientWidth && data?.descriptions?.length > 0) {
            const coordinatesX = data.descriptions.map((item) => item.x1)
            const coordinatesY = data.descriptions.map((item) => item.y1)

            setMaxSeatingChildrenX(Math.max(...coordinatesX))
            setMaxSeatingChildrenY(Math.max(...coordinatesY))

            const scaleFactor = getScaleFactor(clientWidth)
            setScaleFactor(scaleFactor)
        }
    }, [data, clientWidth])

    const { offsetX, offsetY } = useMemo(() => getSeatingOffsets(data, scaleFactor), [data, scaleFactor])

    return { maxSeatingChildrenX, maxSeatingChildrenY, scaleFactor, clientWidth, offsetX, offsetY }
}
